<template>
  <transition v-if="show" name="fade">
    <tr :class="{ 'opacity-03 disabled': pending }" class="show align-top">
      <td :title="'Edit in Details Page'" class="image-cell" style="width:248px">
        <div v-if="product.thumbnail_image" class="flex">
          <router-link
            class="flex align-center justify-center"
            :to="{ name: 'editProduct', params: { productId: product.product_id } }">
            <img
              class="panel-thumbnail"
              :src="product.thumbnail_image" />
            <div class="flex align-center justify-center ml-10">
              {{ product.product_name }}
            </div>
          </router-link>
        </div>
        <div
          v-else
          class="flex"
        >
          <router-link
            class="flex align-center justify-center"
            :to="{ name: 'editProduct', params: { productId: product.product_id } }">
            <img
              class="object-fit-contain align-center panel-thumbnail"
              src="@/assets/img/icons/icon-upload-image.svg"
            />
            <div class="flex align-center justify-center ml-10">{{ product.product_name }}</div>
          </router-link>
        </div>
      </td>
      <td width="111">
        <toggle
          class="mt-25"
          v-model="isTracked"
        />
      </td>
      <td width="146" class="">
        <div class="">
          <div v-for="variant, i in product.variants"
               :key=i
               class="mb-20"
          >
            <inventory-name
              :data="variant.characteristic_options"
              @variant-height="setHeight"
            />
          </div>
        </div>
      </td>
      <td width="146">
        <div class="">
          <div v-for="variant, i in product.variants"
               :key=i
               class="mb-20 flex align-center relative"
               :style="`height: ${height}px`"
          >
            <input
              v-model="variant.sku"
              type="text"
              :name="'sku'+i"
              v-validate="'required'"
              class="width-116"
              :class="{ 'input-error': variant.duplicate || errors.first('sku'+i) }"
            />
            <div
              v-if="variant.duplicate"
              class="color-red subheading-3 sku-exists-error"
              style="bottom:-4px; padding-left: 3px; font-size: 0.625rem;"
            >
              SKU already Exists
            </div>
          </div>
        </div>
      </td>
      <td width="146">
        <div class="">
          <div v-for="(variant, i) in product.variants"
               :key=i
               class=""
          >
            <div
              v-if="isTracked"
              class="mb-20 flex align-center"
              :style="`height: ${height}px`"
            >
              <input
                v-model="variant.inventory_quantity"
                v-validate="'required'"
                type="number"
                :name="'inventory'+i"
                class="width-116"
                :class="{ 'input-error': errors.first('inventory'+i) }"
              />
            </div>
            <div v-else class="mb-20 flex align-center"
                 :style="`height: ${height}px`"
            >
              <toggle v-model="variant.in_stock" :label="'in stock'" class="height-35" />
            </div>
          </div>
        </div>
      </td>
      <td class="">
        <div class="mt-15">
          <bulletin-button size="xsm" @click="handleSaveInventoryClick"> Save</bulletin-button>
          <VPopover offset="16" class="inline-block">
            <span class="pointer pl-5">...</span>
            <template slot="popover">
              <div @click="getEditDraftRouteConfig" class="pointer underline-hover"> Edit in Detail Page</div>
              <!--              <span class="mx-5">•</span>-->
              <!--              <span class="pointer underline-hover" @click="handleDeleteClick">Delete</span>-->
            </template>
          </VPopover>
        </div>
      </td>
    </tr>
  </transition>
</template>
<script>
import Vue from "vue";
import { VTooltip, VPopover, VClosePopover } from "v-tooltip";
import DraftApi from "@/services/api/draftApi";
import ProductApi from "@/services/api/productApi";
import { mapGetters } from "vuex";
import inventoryName from "@/views/dashboard/inventory/inventoryName";
import InventoryApi from "@/services/api/inventorytApi";
import { inventoryHelper } from "@/components/mixin/inventoryHelper";

Vue.directive("tooltip", VTooltip);
Vue.directive("close-popover", VClosePopover);
Vue.component("VPopover", VPopover);

const DraftApiService = new DraftApi(),
  InventoryApiService = new InventoryApi(),
  ProductApiService = new ProductApi();
export default {
  name: "InventoryRecord",
  props: ["data", "productTypes", "i"],
  mixins: [inventoryHelper],
  components: { inventoryName },
  data() {
    return {
      product: this.data,
      isTracked: this.data.track_inventory,
      pending: false,
      show: true,
      invalid: false,
      userEditedProduct: false,
      categories: null,
      height: '35'
    };
  },
  computed: {
    ...mapGetters({
      user: "userState"
    })
  },
  watch: {
    productTypes: function() {
      this.$validator.validate();
    },
    product: {
      handler() {
        this.userEditedProduct = true;
      },
      deep: true
    }
  },
  methods: {
    handleAddVariantClick: function() {
      this.product.validVariant = true;
    },
    handleSaveInventoryClick: async function() {
      const isValid = await this.$validator.validate();
      if (!isValid) {
        this.$swal("Attention", "Please fill out all required fields");
        return;
      }

      if (this.isTracked) {
        await this.updateProductInventory();
      } else {
        try {
          await this.updateProductStock(this.product);
          await this.$swal("Alert", "Inventory Updated");
        } catch (err) {
          const { status_text, error_message } = err.response.data;
          await this.$swal("Alert", `${status_text} ${error_message}`);

        }
      }

    },
    async updateProductInventory() {
      const payload = {
        product_id: this.product.product_id,
        track_inventory: this.isTracked,
        variants: this.product.variants.map(variant => {
          return {
            variant_id: variant.variant_id,
            inventory_quantity: variant.inventory_quantity,
            sku: variant.sku
          };
        })
      };
      try {
        const { data } = await InventoryApiService.setInventoryForProduct(this.product.product_id, payload);
        const variantIDsWithSKUSErrors = data.variants.map(variant => variant.variant_id);
        const hasErrors = variantIDsWithSKUSErrors.length !== 0;
        if (hasErrors) {
          this.product.variants.forEach((variant) => {
            if (variantIDsWithSKUSErrors.includes(variant.variant_id)) {
              variant.duplicate = true;
            } else {
              variant.duplicate = false;
            }
          });
        } else {
          this.product.variants.forEach((variant) => {
            delete variant.duplicate;
          });
          await this.$swal("Alert", "Inventory Updated");
        }
        this.$forceUpdate();
      } catch (err) {
        await this.$swal("Alert", "Something went wrong. Please try again later");
      }

    },
    handleDeleteClick: async function() {
      const { value: success } = await this.$swal({
        title: "Attention",
        text: "Are you sure you want to delete this draft post",
        showCancelButton: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes"
      });
      if (success) {
        this.pending = true;
        await ProductApiService.removeProduct(this.product.id);
        this.$emit("remove-product", this.product.id);
        // this.$store.dispatch("getDraftCount");
        this.show = false;
      }
    },
    selectProductType: function(productType) {
      if (this.product.categories.find((item) => item.entity_id === productType.entity_id)) {
        this.product.categories = this.product.categories.filter((item) => item.entity_id !== productType.entity_id);
      } else {
        this.product.categories.push(productType);
      }
    },
    getEditDraftRouteConfig: function() {
      //   let query = undefined;
      //   if (this.user?.role === "ADMIN" || this.user?.role === "PRODUCT_BUILDER") {
      //     query = this.$route.query;
      //   }
      //   return { name: "dashboardDraftEdit", params: { productId: this.product.product_id }, query };
      // for some reason router is not working here so I used a hard redirect
      window.location.replace(`/dashboard/products/${this.product.product_id}/edit`);
    },
    setHeight(height) {
      this.height = height;
    }
  }
};
</script>

<style type="scss" scoped>

.width-116 {
  width: 116px;
}

.height-35 {
  height: 35px;
  line-height: 35px;
}

.panel-thumbnail {
  width: 60px;
  height: 75px;
}

input,
select {
  border-radius: 4px !important;
  padding: 8px 6px;
}
.sku-exists-error {
  position:absolute;
  bottom:-4px;
  padding-left: 3px;
  font-size: 0.625rem;
  letter-spacing: 0.07em;
}
</style>
